import { WebPlugin } from '@capacitor/core';
export class SimWeb extends WebPlugin {
    async getSimCards() {
        throw this.unimplemented('Sim.getSimCards is not implemented on web.');
    }
    async checkPermissions() {
        return { readSimCard: 'denied' };
    }
    async requestPermissions() {
        return this.checkPermissions();
    }
    async getPluginVersion() {
        return { version: 'web' };
    }
}
//# sourceMappingURL=web.js.map